import React, { useState } from "react";
import {
    Form,
    Input,
    Row,
    Col,
    Checkbox,
    Collapse,
    ColorPicker,
    Button,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import PhotoButton from "../../../qforms/standard_elements/PhotoButton";
import log from "cslog";
import Cstyles from "./style/BrandEditPage.module.css";
import PhotoButtonMinimal from "../../../qforms/standard_elements/PhotoButtonMinimal";
import {
    ThemeColorPicker,
    ThemeGenerateModal,
} from "../../../qmade/creator/GSBox";

export function BrandThemePalettePicker({ value, onChange, onChangeThemes }) {
    return (
        <>
            <ThemeGenerateModal
                value={value}
                onChange={onChange}
                trigger={<Button>{value ? "Regenerate" : "Generate"}</Button>}
                onChangeThemes={onChangeThemes}
            />
            {value && (
                <ThemeColorPicker
                    // theme={config}
                    value={value}
                    initial_theme={value}
                    onChange={(new_val) => {
                        onChange(new_val);
                    }}
                    onChangeThemes={onChangeThemes}
                />
            )}
        </>
    );
}

function BrandAssetsForm({ form }) {
    return (
        <>
            <Row gutter={[10, 10]}>
                <Col xs={24} sm={12} md={12}>
                    <Form.Item label="Default Logo" name="logo">
                        <PhotoButtonMinimal
                            field={{
                                collection: "qqq",
                                field: "logo",
                            }}
                            width="220px"
                            height="100px"
                            objectFit="contain"
                            show_placeholder={true}
                            show_choose={false}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={12}>
                    <Form.Item label="Square Logo" name="logo_square">
                        <PhotoButtonMinimal
                            field={{
                                collection: "qqq",
                                field: "logo_square",
                            }}
                            height="100px"
                            width="100px"
                            objectFit="contain"
                            show_placeholder={true}
                            show_choose={false}
                        />
                    </Form.Item>
                    <Checkbox
                        onChange={(e) => {
                            if (e.target.checked) {
                                log.d(
                                    form.getFieldValue("logo"),
                                    "settintg logo_square to"
                                );
                                form.setFieldsValue({
                                    logo_square: form.getFieldValue("logo"),
                                    logo_square_old:
                                        form.getFieldValue("logo_square"),
                                });
                            } else {
                                if (
                                    form.getFieldValue("logo_square") ===
                                    form.getFieldValue("logo")
                                ) {
                                    form.setFieldsValue({
                                        logo_square:
                                            form.getFieldValue(
                                                "logo_square_old"
                                            ) || null,
                                    });
                                }
                            }
                            log.d(form.getFieldsValue(), "form values now");
                        }}
                    >
                        Use same as default logo
                    </Checkbox>
                </Col>

                <Col xs={24} sm={12} md={12}>
                    <Form.Item
                        label="Default Logo (for dark background)"
                        name="logo_dark"
                    >
                        <PhotoButtonMinimal
                            field={{
                                collection: "qqq",
                                field: "logo_dark",
                            }}
                            width="220px"
                            height="100px"
                            objectFit="contain"
                            show_placeholder={true}
                            background="black"
                            enable_remove_bg={false}
                            show_choose={false}
                        />
                    </Form.Item>
                    <Checkbox
                        style={{ paddingBottom: "10px" }}
                        onChange={(e) => {
                            if (e.target.checked) {
                                log.d(
                                    form.getFieldValue("logo"),
                                    "settintg logo_dark to"
                                );
                                form.setFieldsValue({
                                    logo_dark: form.getFieldValue("logo"),
                                    logo_dark_old:
                                        form.getFieldValue("logo_dark"),
                                });
                            } else {
                                if (
                                    form.getFieldValue("logo_dark") ===
                                    form.getFieldValue("logo")
                                ) {
                                    form.setFieldsValue({
                                        logo_dark:
                                            form.getFieldValue(
                                                "logo_dark_old"
                                            ) || null,
                                    });
                                }
                            }
                            log.d(form.getFieldsValue(), "form values now");
                        }}
                    >
                        Use same as default logo
                    </Checkbox>
                </Col>
            </Row>

            <br />
            <Form.Item
                label="Brand Colors"
                name="brand_colors"
                tooltip="Select colors for your brand palette"
            >
                <BrandThemePalettePicker
                    onChangeThemes={(new_theme_arr) => {
                        form.setFieldValue("color_palettes", new_theme_arr);
                    }}
                />
            </Form.Item>

            {/* <Row gutter={[10, 10]}>
                <Col xs={24} sm={12}>
                    <Form.Item label="Primary Phone" name="primary_phone">
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                    <Form.Item label="Primary Email" name="primary_email">
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item label="Address" name="address">
                <TextArea rows={3} />
            </Form.Item>
            <Form.Item label="Website" name="website">
                <Input />
            </Form.Item> */}

            {/* <Collapse
                // defaultActiveKey={["1"]}
                defaultActiveKey={[]}
                // ghost
                items={[
                    {
                        key: "1",
                        label: "Social Media Handles",
                        children: (
                            <div>
                                <Row gutter={[10, 10]}>
                                    <Col xs={24} sm={12}>
                                        <Form.Item
                                            label="Linkedin Handle"
                                            name="linkedin_handle"
                                            help="Mention only handle, not full url"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <Form.Item
                                            label="Instagram Handle"
                                            name="instagram_handle"
                                            help="Mention only handle, not full url"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[10, 10]}>
                                    <Col xs={24} sm={12}>
                                        <Form.Item
                                            label="Facebook Handle"
                                            name="facebook_handle"
                                            help="Mention only handle, not full url"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <Form.Item
                                            label="YouTube Handle"
                                            name="youtube_handle"
                                            help="Mention only handle, not full url"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[10, 10]}>
                                    <Col xs={24} sm={12}>
                                        <Form.Item
                                            label="Pinterest Handle"
                                            name="pinterest_handle"
                                            help="Mention only handle, not full url"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                ]}
            /> */}
        </>
    );
}

export default BrandAssetsForm;
